<template>
  <div>
    <div class="MobileHide">
      <ul class="list-group">
        <div v-if="!cookiesObject.token">
          <h3
            class="MobileHide"
            style="text-align: center; font-weight: 600; color: #242224"
          >
            {{ $t("LanguageEn.txtRestrictToLogin") }}
          </h3>
          <h3
            class="MobileShow"
            style="
              text-align: center;
              font-weight: 600;
              color: #1b5e20;
              margin-top: 50px;
            "
          >
            {{ $t("LanguageEn.txtRestrictToLogin") }}
          </h3>
        </div>
        <div v-for="fav in favsTe" :key="fav.key" v-else>
          <li class="list-group-item game" style="background: #141416">
            <div class="row">
              <div class="col-1 bodyElement">
                <b-btn
                  v-if="cookiesObject.token"
                  @click="(ids = fav.id), $refs['remove-modal2'].show()"
                  style="
                    background: none;
                    width: 5px;
                    height: 20px;
                    margin-top: -5px;
                    border-radius: 25px;
                    border: none;
                  "
                >
                  <img
                    src="@/assets/delete.png"
                    style="width: 10px; margin-top: -20px; margin-left: -7.5px"
                    alt=""
                  />
                </b-btn>
              </div>
              <router-link
                class="col"
                style="color: white"
                id="router-link"
                :to="{ name: 'MatchPagePar', params: { gameId: fav.id } }"
              >
                <div class="row">
                  <div class="col-1 bodyElement">
                    {{ fav.matchStatus.name }}
                  </div>
                  <div
                    class="col bodyElement"
                    style="margin-top: -5px; text-align: right"
                  >
                    {{ fav.team1.name | transliterate(cookiesObject.lang) }}
                    <img
                      :src="teamLogo + fav.team1.id"
                      alt=""
                      style="width: 20px"
                    />
                  </div>
                  <div
                    class="col-2 bodyElement"
                    v-if="
                      fav.matchStatus.name == 'NS' ||
                      fav.matchStatus.name == 'POSTP' ||
                      fav.matchStatus.name == 'CANCL'
                    "
                    style="letter-spacing: 3px"
                  >
                    -
                  </div>
                  <div
                    class="col-2 bodyElement"
                    style="letter-spacing: 3px"
                    v-else
                  >
                    {{ fav.currentScore | transliterate(cookiesObject.lang) }}
                  </div>
                  <div
                    class="col bodyElement"
                    style="margin-top: -5px; text-align: left"
                  >
                    <img
                      :src="teamLogo + fav.team2.id"
                      alt=""
                      style="width: 20px"
                    />
                    {{ fav.team2.name | transliterate(cookiesObject.lang) }}
                  </div>
                </div>
              </router-link>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <div class="container MobileShow" style="background: #212529">
      <div>
        <div v-if="!cookiesObject.token">
          <h3
            class="MobileShow"
            style="
              text-align: center;
              font-weight: 600;
              color: white;
              margin-top: 50px;
            "
          >
            {{ $t("LanguageEn.txtRestrictToLogin") }}
          </h3>
        </div>
        <b-tabs
          content-class="mt-0"
          justified
          style="background: #1a1a1d; color: white !important"
          nav-class="css1"
          active-nav-item-class="css"
          v-else
        >
          <b-tab active>
            <template v-slot:title>
              <p style="margin: 0px; color: white; font-size: 12px">
                {{ $t("LanguageEn.txtMatch") }}
              </p>
            </template>
            <ul class="list-group">
              <div v-for="fav in favsTe" :key="fav.key">
                <li class="list-group-item game" style="background: #141416">
                  <div class="row">
                    <div class="col-1 bodyElement">
                      <b-btn
                        v-if="cookiesObject.token"
                        @click="(ids = fav.id), $refs['remove-modal2'].show()"
                        style="
                          background: none;
                          width: 5px;
                          height: 20px;
                          margin-top: -5px;
                          border-radius: 25px;
                          border: none;
                        "
                      >
                        <img
                          src="@/assets/delete.png"
                          style="
                            width: 10px;
                            margin-top: -20px;
                            margin-left: -7.5px;
                          "
                          alt=""
                        />
                      </b-btn>
                      <b-btn
                        v-else
                        v-b-popover.hover.right="'Log in to add to favorites!'"
                        style="
                          float: right;
                          margin-right: 10px;
                          margin-top: 5px;
                          background: none;
                          width: 5px;
                          height: 5px;
                          border: none;
                        "
                      >
                        <img
                          src="@/assets/delete.png"
                          style="
                            width: 10px;
                            margin-top: -30px;
                            margin-left: -10px;
                          "
                          alt=""
                        />
                      </b-btn>
                    </div>
                    <router-link
                      class="col"
                      style="color: lightgrey"
                      id="router-link"
                      :to="{ name: 'MatchPagePar', params: { gameId: fav.id } }"
                    >
                      <div class="row">
                        <div class="col-1 bodyElement">
                          {{ fav.matchStatus.name }}
                        </div>
                        <div class="col bodyElement">
                          {{
                            fav.team1.name | transliterate(cookiesObject.lang)
                          }}
                        </div>
                        <div class="col-1 bodyElement">
                          {{ fav.currentScore }}
                        </div>
                        <div class="col bodyElement">
                          {{
                            fav.team2.name | transliterate(cookiesObject.lang)
                          }}
                        </div>
                      </div>
                    </router-link>
                  </div>
                </li>
              </div>
            </ul>
          </b-tab>
          <b-tab style="background: #212529">
            <template v-slot:title>
              <p style="margin: 0px; color: white; font-size: 12px">
                {{ $t("LanguageEn.txtTeams") }}
              </p>
            </template>
            <HeaderBody />
          </b-tab>
          <b-tab style="background: #212529">
            <template v-slot:title>
              <p style="margin: 0px; color: white; font-size: 12px">
                {{ $t("LanguageEn.txtLeagues") }}
              </p>
            </template>
            <Tournaments />
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal
      ref="remove-modal2"
      header-class="sureModal2"
      body-class="sureModal2"
      size="md"
      hide-footer
      centered
      title=""
    >
      <p style="text-align: center; font-size: 12px; color: #a3a3a3">
        {{ $t("LanguageEn.removeGame") }}
      </p>
      <b-row>
        <b-col style="text-align: center">
          <b-button
            type="submit"
            class=""
            style="
              background: #bb4250;
              border: none;
              border-radius: 2px;
              width: 180px;
            "
            @click="
              removeFavorite({ value: ids, type: match }),
                $refs['remove-modal2'].hide()
            "
            >{{ $t("LanguageEn.remove") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeaderBody from "../LeftColumn/HeaderBody";
import Tournaments from "../LeftColumn/Tournaments";

export default {
  name: "MyGames",
  data() {
    return {
      spinning: "",
      gameId: "",
      cookiesObject: "",
      match: "match",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      ids: "",
    };
  },
  async mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;
  },

  methods: {
    ...mapActions(["removeFavorite"]),
  },
  components: {
    HeaderBody,
    Tournaments,
  },
  props: {},
  computed: {
    ...mapGetters(["favsTe"]),
  },
};
</script>

<style scoped>
#router-link {
  color: black;
  text-decoration: none;
}

li {
  line-height: 5px;
  border-radius: 0px !important;
  font-size: 12px;
}
.LeagueName {
  margin-bottom: 10px;
}

.header {
  background: #242424;
  color: white;
}

.bodyElement {
  padding: 0;
  height: 8px;
}

.game {
  text-align: center;
}
.game :hover {
  color: #309a3d;
}

@media only screen and (max-width: 770px) {
  .bodyElement {
    padding: 0;
    height: 8px;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .bodyElement {
    padding: 0;
    height: 8px;
  }
  .MobileShow {
    display: none;
  }
}
</style>
<style>
.css {
  background: none !important;
  border-radius: 0px !important;
  border-bottom: solid #357439 !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  color: white !important;
}
.css1 {
  background: none !important;
  border-radius: 0px !important;
  border: none;
  color: white !important;
}
.sureModal2 {
  background: #212225;
  color: lightgrey;
  border: none;
  font-size: 12px !important;
}
.sureModal2 .modal-title {
  font-size: 15px !important;
}
.sureModal2 .close {
  color: white !important;
}
</style>